import { render, staticRenderFns } from "./LogTable.vue?vue&type=template&id=3c4879ae&scoped=true"
import script from "./LogTable.vue?vue&type=script&lang=js"
export * from "./LogTable.vue?vue&type=script&lang=js"
import style0 from "./LogTable.vue?vue&type=style&index=0&id=3c4879ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4879ae",
  null
  
)

export default component.exports